import {hasPermission} from "@bounce/shared/helpers/permissionUtils";
import {LoadingScreen} from "@bounce/shared/ui";
import React, {useMemo} from "react";
import {Navigate} from "react-router-dom";
import {useBackofficeUser} from "contexts";
import {PermissionGuardProps} from "declerations/server/permission_guard_models";
import {urls} from "../../urls";

export const PermissionGuard = ({children, permission, fallback}: PermissionGuardProps) => {
  const {rolePermission, hasSpringPermission} = useBackofficeUser();

  const permissions = rolePermission ?? [];

  const hasAccess = useMemo(() => {
    if (!permission) {
      return hasSpringPermission;
    }
    return hasPermission(permissions, permission);
  }, [permissions, permission, hasSpringPermission]);

  if (!rolePermission) {
    return <LoadingScreen />;
  }

  if (!hasAccess) {
    const fallbackUrl = hasSpringPermission ? urls.searchSpring.url : urls.search.url;
    return <>{fallback || <Navigate to={fallbackUrl} replace />}</>;
  }

  return <>{children}</>;
};
